import { HostTutorResponse, TutorProfileStatus } from '../models/Tutor';

export function hostTutorDisplayName(tutor: HostTutorResponse): string {
  return (
    tutor.name?.trim() ||
    tutor.spaceName?.trim() ||
    tutor.headline?.trim() ||
    tutor.tutorId
  );
}

export function normalizeHostTutorStatus(status?: string | null): TutorProfileStatus | 'UNKNOWN' {
  const key = (status || 'ACTIVE').toUpperCase();
  if (key === 'INVITED' || key === 'ACTIVE' || key === 'SUSPENDED') return key;
  return 'UNKNOWN';
}

export function hostTutorStatusColor(
  status?: string | null
): 'success' | 'warning' | 'error' | 'default' {
  switch (normalizeHostTutorStatus(status)) {
    case 'ACTIVE':
      return 'success';
    case 'INVITED':
      return 'warning';
    case 'SUSPENDED':
      return 'error';
    default:
      return 'default';
  }
}
